import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import i18n from './i18n'
import { vMaska } from 'maska/vue'
import { loadConfig } from './plugins/config';
import router from '@/router';

window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  window.location.reload()
})

loadConfig().then((loadedConfig) => {
  const app = createApp(App)

  app.config.globalProperties.$config = loadedConfig;

  app.use(vuetify)
  app.use(i18n)
  app.use(router)

  app.directive('mask', vMaska)

  app.mount('#app')
});
